import { Button, Card, CardBody, CardTitle, Col, Container, Row } from "react-bootstrap";
import { ResumeState } from "../../blocs/resume/ResumeState";
import SearchElementTile from "../SearchElementTile";
import MarkdownEditor from "@uiw/react-markdown-editor";

export default function ResumeBodyV2(downloadResume: () => void, state: ResumeState) {
    return <Container style={{ paddingTop: 8 }}>
        <Row>
            <Col xs={window.innerWidth > 991 ? 9 : 12}>
                <Card style={{ padding: 16 }}>
                    <CardTitle>Resume::{state.data?.createdAt?.toDate()?.toDateString()}</CardTitle>
                    <CardBody><MarkdownEditor.Markdown
                        style={{
                            fontFamily: "Ubuntu Mono",
                        }}
                        source={state.data?.markdown}
                        wrapperElement={{
                            "data-color-mode": "light",
                        }}
                    /></CardBody>
                </Card>
            </Col>
            <Col>
                <Card style={{
                    padding: 16,
                    marginTop: window.innerWidth > 991 ? 0 : 8,
                }}>
                    <CardTitle>Download the PDF version</CardTitle>
                    <CardBody style={{ padding: 0 }}>
                        <Button
                            variant="dark"
                            onClick={downloadResume}
                            style={{ borderRadius: 90, width: '100%'}}
                        >
                            👇Download
                        </Button>
                    </CardBody>
                </Card>
                {
                    state.data?.similarArticles && <Card style={{
                        padding: 16,
                        marginTop: 8,
                    }}>
                        <CardTitle>Related articles</CardTitle>
                        <CardBody style={{ padding: 0 }}>
                            {
                                state.data!.similarArticles!.map((target, index) => <div style={{
                                    borderWidth: 1,
                                    borderColor: "#d2d2d2",
                                    borderStyle: "solid",
                                    margin: 2,
                                    padding: 2,
                                    marginBottom: 8,
                                    borderRadius: 4,
                                }}>
                                    <SearchElementTile target={target} key={index} />
                                </div>)
                            }
                        </CardBody>
                    </Card>
                }
            </Col>
        </Row>
    </Container>;
}
